import { useState } from 'react';
import { toast } from 'react-toastify';
import { Building2, Phone, Mail, MapPin, Globe, FileText, Save } from 'lucide-react';
import { Button } from '@components/ui';

export default function GeneralSettings() {
    const [settings, setSettings] = useState({
        companyName: 'İNSAET',
        ownerName: 'Mücahit Çetin',
        phone: '0506 101 05 01',
        email: 'info@insaet.com',
        address: 'Çukurova, Adana',
        taxNo: '1234567890',
        taxOffice: 'Çukurova Vergi Dairesi',
        website: 'insaet.com',
    });

    const handleChange = (key, value) => {
        setSettings(prev => ({ ...prev, [key]: value }));
    };

    const handleSave = () => {
        toast.success('Şirket bilgileri kaydedildi');
    };

    const InputField = ({ icon: Icon, label, field, type = 'text', placeholder }) => (
        <div>
            <label className="flex items-center gap-2 text-sm font-medium text-text-secondary mb-2">
                <Icon size={15} className="text-text-muted" />
                {label}
            </label>
            <input
                type={type}
                className="w-full px-4 py-3 rounded-xl border border-border-light bg-bg-primary text-text-primary placeholder:text-text-muted focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                value={settings[field]}
                onChange={(e) => handleChange(field, e.target.value)}
                placeholder={placeholder}
            />
        </div>
    );

    return (
        <div className="space-y-6">
            <div>
                <h2 className="text-xl font-bold text-text-primary">Şirket Bilgileri</h2>
                <p className="text-text-tertiary text-sm mt-1">Şirket ve iletişim bilgilerinizi yönetin</p>
            </div>

            {/* Company Info Section */}
            <div className="bg-bg-tertiary/30 rounded-xl border border-border-light p-6">
                <div className="flex items-center gap-3 mb-6">
                    <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
                        <Building2 size={24} className="text-primary" />
                    </div>
                    <div>
                        <h3 className="font-semibold text-text-primary">Temel Bilgiler</h3>
                        <p className="text-sm text-text-tertiary">Şirketinizin temel bilgileri</p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    <InputField icon={Building2} label="Şirket Adı" field="companyName" placeholder="Şirket adı" />
                    <InputField icon={FileText} label="Şirket Sahibi" field="ownerName" placeholder="Ad Soyad" />
                    <InputField icon={Phone} label="Telefon" field="phone" type="tel" placeholder="0xxx xxx xx xx" />
                    <InputField icon={Mail} label="E-posta" field="email" type="email" placeholder="info@sirket.com" />
                    <div className="md:col-span-2">
                        <InputField icon={MapPin} label="Adres" field="address" placeholder="Şirket adresi" />
                    </div>
                </div>
            </div>

            {/* Tax Info Section */}
            <div className="bg-bg-tertiary/30 rounded-xl border border-border-light p-6">
                <div className="flex items-center gap-3 mb-6">
                    <div className="w-12 h-12 rounded-xl bg-tertiary/10 flex items-center justify-center">
                        <FileText size={24} className="text-tertiary" />
                    </div>
                    <div>
                        <h3 className="font-semibold text-text-primary">Vergi Bilgileri</h3>
                        <p className="text-sm text-text-tertiary">Fatura ve resmi işlemler için</p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    <InputField icon={FileText} label="Vergi Numarası" field="taxNo" placeholder="Vergi numarası" />
                    <InputField icon={Building2} label="Vergi Dairesi" field="taxOffice" placeholder="Vergi dairesi" />
                    <InputField icon={Globe} label="Web Sitesi" field="website" placeholder="www.sirket.com" />
                </div>
            </div>

            <div className="flex justify-end">
                <Button variant="primary" icon={<Save size={18} />} onClick={handleSave}>
                    Değişiklikleri Kaydet
                </Button>
            </div>
        </div>
    );
}
